//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    layout: 'simple',
    head() {
        return {
            title: 'UX research op de kaart zetten.',
            meta: [
                {
                    name: 'robots',
                    content: 'noindex,follow',
                },
            ],
        };
    },
};
